// Modules
import styled from 'styled-components'
export const ModalContainer = styled.div`
    & > div {
        z-index: 2;
    }

    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
        & > div > div > div > span {
            margin-top: 24px;
        }
    }
`

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
        justify-content: flex-start;
    }
`

export const ModalImg = styled.img`
    height: 148px;
    width: 148px;
`

interface ModalContentProps {
    sizeTitleMobile?: string
}

export const ModalContent = styled.div<ModalContentProps>`
    margin: 1em 1em 1.5em 1em;

    & .modal__title {
        margin-bottom: 16px;
        font-weight: 700;
        font-size: 32px;
        line-height: 40px;
    }

    & .modal__subtitle {
        margin-bottom: 1em;
    }

    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
        & .modal__title {
            margin-bottom: 16px;
            font-weight: 700;
            font-size: ${({ sizeTitleMobile }) => (sizeTitleMobile ? sizeTitleMobile : '44px')};
            line-height: 44px;
        }
    }
`
